import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close_sm",
  "use": "icon-close_sm-usage",
  "viewBox": "0 0 8.5 8.5",
  "content": "<symbol viewBox=\"0 0 8.5 8.5\" id=\"icon-close_sm\">\n  <path d=\"M1111.74,629.621l-2.12,2.121-2.12-2.121-2.12,2.121-2.12-2.121,2.12-2.121-2.12-2.122,2.12-2.121,2.12,2.121,2.12-2.121,2.12,2.121-2.12,2.122Z\" transform=\"translate(-1103.25 -623.25)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol